"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const scale_1 = require("../../2d/utilities/scale");
function get2DRange(draft, options) {
    const { startX, startY, endX, endY } = options;
    const scaleX = (0, scale_1.get2DXScale)(draft);
    const scaleY = (0, scale_1.get2DYScale)(draft);
    const x1 = startX * 1000000 > endX * 1000000 ? endX : startX;
    const x2 = startX * 1000000 > endX * 1000000 ? startX : endX;
    const y1 = startY * 1000000 > endY * 1000000 ? endY : startY;
    const y2 = startY * 1000000 > endY * 1000000 ? startY : endY;
    const fromY = scaleY.invert(y1);
    const fromX = scaleX.invert(x1);
    const toY = scaleY.invert(y2);
    const toX = scaleX.invert(x2);
    return { fromX, fromY, toX, toY };
}
exports.default = get2DRange;
